import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';
export default function UseSendMail(cb) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(apiEndPoints.SEND_MAILS, data);
      return response?.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data.message });
        queryClient.invalidateQueries('get-mails');
        cb();
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
        cb();
        
      },
    }
  );
}
